import React from 'react';
import PropTypes from 'prop-types';
import { TRANSLATE_PREFIX, trackingLinkKeyFromMacro } from '../../consts';
import Input, { HINT_VARIANTS } from '../Input';
import css from './ParameterKeyCell.css';

const TAB_PREFIX = `${TRANSLATE_PREFIX}.POSTBACK_TEMPLATES_TAB`;

const isNetworkEqualsMacro = macro => /^\{NETWORK=[^{}]+\}$/.test(macro || '');

// `{x=<placeholder>}` style macros (e.g. {IS_ASSIST=<placeholder>}) hint at `x`.
const NETWORK_MATCH_MACRO_PATTERN = /^\{([^={}]+)=[^{}]+\}$/;

const networkMatchKeyFromMacro = macro => {
    const match = NETWORK_MATCH_MACRO_PATTERN.exec(macro || '');
    return match ? match[1].toLowerCase() : null;
};

const placeholderKeyFromMacro = macro => {
    if (isNetworkEqualsMacro(macro)) return 'is_attributed';
    return trackingLinkKeyFromMacro(macro) || networkMatchKeyFromMacro(macro) || macro.slice(1, -1).toLowerCase();
};

const ParameterKeyCell = ({ row, onChange, readOnly, translate }) => {
    const { duplicateKey, isAutoFilled, isRequired, requiredByTemplateLabel } = row;
    const paramError =
        !readOnly && row.paramErrorKey ? translate(`${TRANSLATE_PREFIX}.ERRORS.${row.paramErrorKey}`) : null;
    const duplicateError = !readOnly && duplicateKey ? translate(`${TAB_PREFIX}.DUPLICATE_KEY_HINT`) : null;
    const isEmpty = !(row.partner_parameter_key || '').trim();
    const requiredByTemplateError =
        !readOnly && isRequired && isEmpty
            ? translate(`${TAB_PREFIX}.REQUIRED_BY_TEMPLATE_HINT`, { template: requiredByTemplateLabel })
            : null;
    const error = paramError || duplicateError || requiredByTemplateError;
    return (
        <td>
            <Input
                value={row.partner_parameter_key || ''}
                placeholder={
                    readOnly
                        ? undefined
                        : translate(`${TAB_PREFIX}.PARAMETER_KEY_PLACEHOLDER`, {
                              key: row.templateKey || row.defaultKey || placeholderKeyFromMacro(row.singular_macro),
                          })
                }
                onChange={val => onChange(row.singular_macro, val)}
                disabled={readOnly}
                required={!readOnly}
                error={error}
                hint={isAutoFilled ? translate(`${TAB_PREFIX}.AUTO_FILLED_HINT`) : undefined}
                hintVariant={HINT_VARIANTS.INFO}
                inputClassName={isAutoFilled ? css.autoFilledInput : undefined}
                containerClass={css.keyInput}
            />
        </td>
    );
};

ParameterKeyCell.propTypes = {
    row: PropTypes.shape({
        singular_macro: PropTypes.string.isRequired,
        partner_parameter_key: PropTypes.string,
        paramErrorKey: PropTypes.string,
        duplicateKey: PropTypes.bool,
        isAutoFilled: PropTypes.bool,
        isRequired: PropTypes.bool,
        requiredByTemplateLabel: PropTypes.string,
        templateKey: PropTypes.string,
        defaultKey: PropTypes.string,
    }).isRequired,
    onChange: PropTypes.func.isRequired,
    readOnly: PropTypes.bool,
    translate: PropTypes.func.isRequired,
};

export default ParameterKeyCell;
